import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportingService } from '../../services/reportingService';

export const useGetPendingReports = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.reporting.pending_reports],
    queryFn: () =>
      reportingService.pendingReports().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }

        return null;
      }),
  });
};
